function getRandomNumFromMsec(maxNum) {
    const date = new Date();
    return date.getMilliseconds() % maxNum;
}

function getRandomNumFromDate(maxNum) {
    const date = new Date();
    return date.getDate() % maxNum;
}

export default {
    getRandomNumFromMsec,
    getRandomNumFromDate
}